<img [src]="data.imagePath" alt="Imagen" class="imagen">
<!-- data.imagePath -->


